// extracted by mini-css-extract-plugin
export default {"container":"fo-z","ratingLayout":"go-z","ratingLabel":"ho-z","nonInteractiveRatingLabel":"io-z"};